import { Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { LocalStoreService } from '@frontend/vanilla/core';

import { HELP_BOX_TYPE } from '../../../help-box/help-box-type';
import { HelpBoxService } from '../../../help-box/help-box.service';
import { PopupManager } from '../../../popup/popup-manager.service';

@Component({
    selector: 'ms-help-box-archived-bets',
    templateUrl: './help-box-archived-bets.html',
    standalone: false,
})
export class HelpBoxArchivedComponent {
    private archivedBetsHelpBoxStorageKey = 'archivedBetsHelpBoxClosed';
    constructor(
        private popupManager: PopupManager,
        public sitecore: Sitecore,
        private localStorage: LocalStoreService,
        private helpBoxService: HelpBoxService,
    ) {}

    openArchivedBetsPopup(): void {
        this.popupManager.open('archived-bets');
    }

    onArchivedBetsHelpBoxClose = () => {
        this.localStorage.set(this.archivedBetsHelpBoxStorageKey, true);
    };

    get isArchivedBetsHelpBoxVisible(): boolean {
        return this.helpBoxService.isHelpBoxEnabled(HELP_BOX_TYPE.ArchivedBets) && !this.localStorage.get(this.archivedBetsHelpBoxStorageKey);
    }
}
